import { isCarsTrucks } from '@kijiji/category'
import { type SearchQuery } from '@kijiji/generated/graphql-types'
import { type FC } from 'react'

import { BodyTypeCarousel } from '@/components/brp/BodyTypeCarousel'
import { RemoteToggles } from '@/lib/firebase/config/toggles'
import { useToggle } from '@/lib/firebase/hooks'
import { Flex } from '@/ui/atoms/flex'

type BRPTopCarsTrucksProps = {
  /**
   * Current search category ID
   */
  categoryId: number

  /**
   * Selected filters in the search
   */
  selectedFilters: SearchQuery['filters']

  /**
   * Search keyword
   */
  keywords: SearchQuery['keywords']
}

/**
 * Vertical landing section for BRP
 * It should only be rendered if:
 * - When no filters have been selected
 * - On BRP (Search without a keyword)
 * - When category is Cars & Trucks (ID: 174)
 */
export const BRPTopCarsTrucks: FC<BRPTopCarsTrucksProps> = ({
  categoryId,
  keywords,
  selectedFilters,
}) => {
  const enableTopBrp = useToggle(RemoteToggles.VERTICAL_AUTOS_BRP_TOGGLE.key)
  const isValidCategory = isCarsTrucks(categoryId)
  const isBRP = !keywords?.length
  const hasSelectedFilters = !!selectedFilters.length

  if (!enableTopBrp?.enabled || !isValidCategory || !isBRP || !!hasSelectedFilters) return null

  return (
    <Flex>
      <BodyTypeCarousel />
    </Flex>
  )
}
